var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"80px"}},[_c('a',{attrs:{"href":_vm.koglData?.connCd1,"target":"_blank"}},[_c('img',{staticStyle:{"display":"inline"},attrs:{"alt":_vm.koglData?.connCd2,"src":_vm.koglData?.connCd3}})]),_c('p',{staticStyle:{"padding-top":"10px"}},[_vm._v(_vm._s(_vm.koglData?.connCd4))])])
}
var staticRenderFns = []

export { render, staticRenderFns }